'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuoteShowcase = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShopifySection2 = require('./../ShopifySection');

var _Parallax = require('../../objects/parallax/Parallax');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Quote Showcase
 *    Scripts to create a paralax effect for the quote showcase section.
 *
 *  Version:
 *    1.0.0 - 2020/07/11
 */

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-quote-showcase]';

var QuoteShowcase = exports.QuoteShowcase = function (_ShopifySection) {
  (0, _inherits3.default)(QuoteShowcase, _ShopifySection);

  function QuoteShowcase(container) {
    (0, _classCallCheck3.default)(this, QuoteShowcase);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuoteShowcase.__proto__ || Object.getPrototypeOf(QuoteShowcase)).call(this, container));

    _this.factors = [-0.2, -0.5]; // How much you want to move based on percent
    (0, _Parallax.parallax)(container, _this.factors);

    return _this;
  }

  return QuoteShowcase;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CONTAINER_SELECTOR, QuoteShowcase);